<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/payment-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">全场景一站式综合支付解决方案</div>
      </div>
      <img src="@/assets/Mobile/images/solution/payment01.png" alt="">
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">数字化服务成为老板生意好帮手</div>
      </div>
      <img class="image01" src="@/assets/Mobile/images/solution/payment02.png" alt="">
      <img src="@/assets/Mobile/images/solution/payment03.png" alt="">
      <img class="image03" src="@/assets/Mobile/images/solution/payment04.png" alt="">
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">交易稳定   资金安全有保障</div>
      </div>
      <div class="content">
        <div class="item">
          <span class="title">轻松收银</span>
          <div class="line" />
          <span class="text">多种收款工具，简单操作，开机即用，主流支付，任意选择，摆脱无现金找零的限制，在线收款，随时到账，安全放心。</span>
          <div class="image-wapper">
            <img class="image01" src="@/assets/Mobile/images/solution/payment05.png" alt="">
          </div>
        </div>
        <div class="item">
          <span class="title">便捷支付</span>
          <div class="line" />
          <span class="text">支持线下门店主扫被扫、现金、刷卡，线上 PC、APP、H5、公众号、小程序等多场景全渠道收付款。</span>
          <div class="image-wapper">
            <img class="image02" src="@/assets/Mobile/images/solution/payment06.png" alt="">
          </div>
        </div>
        <div class="item">
          <span class="title">资金安全</span>
          <div class="line" />
          <span class="text">银行级监管账户，专户专用，为客户提供合适的资金存管银行，保障商家资金安全无忧。</span>
          <div class="image-wapper">
            <img class="image03" src="@/assets/Mobile/images/solution/payment07.png" alt="">
          </div>
        </div>
        <div class="item">
          <span class="title">合规交易</span>
          <div class="line" />
          <span class="text">为平台型企业提供收付款、账户管理、资金管理于一体的清算分账合规解决方案，规避二清风险，保障资金流清结算通畅。</span>
          <div class="image-wapper">
            <img class="image04" src="@/assets/Mobile/images/solution/payment08.png" alt="">
          </div>
        </div>
        <div class="item">
          <span class="title">智能分析</span>
          <div class="line" />
          <span class="text">自动生成财务报表，营业数据精准分析，实时掌握收支情况，快捷对账，线上线下交易业绩了如指掌。</span>
          <div class="image-wapper">
            <img class="image05" src="@/assets/Mobile/images/solution/payment09.png" alt="">
          </div>
        </div>
        <div class="item">
          <span class="title">优惠促销</span>
          <div class="line" />
          <span class="text">帮助老板建立消费者客户画像，支持短信群发、优惠券、满减、满返等多类型支付营销，多种促销组合发力，拉新留存有一手。</span>
          <div class="image-wapper">
            <img class="image06" src="@/assets/Mobile/images/solution/payment10.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <Case title="智能支付" />
    <ContactForm info-sources="智能支付" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import Case from '@/Mobile/Mobilecom/Case'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'

export default {
  metaInfo: metaInfo.Payment,
  components: {
    ContactForm,
    Case
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  background-color: #FAFAFA;
  img {
    width: 338px;
    margin: 15px 0 20px 0;
  }
}
.block02 {
  background-color: #F7FDFF;
  img {
    width: 314px;
    margin: 13px 0 17px 0;
  }
  .image01 {
    margin-top: 17px;
  }
  .image03 {
    margin-bottom: 21px;
  }
}
.block03 {
  .content {
    margin-top: 33px;
    padding: 0 16px;
    .item {
      text-align: left;
      margin-bottom: 38px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      .title {
        font-size: 19px;
        font-weight: 600;
        color: #595961;
        line-height: 27px;
      }
      .line {
        margin: 15px 0;
        width: 12px;
        height: 2px;
        background: #3986FF;
      }
      .text {
        font-size: 14px;
        font-weight: 300;
        color: #333333;
        line-height: 22px;
      }
      .image-wapper {
        padding-top: 38px;
        text-align: center;
      }
      .image01 {
        width: 246px;
      }
      .image02 {
        width: 275px;
      }
      .image03 {
        width: 258px;
      }
      .image04 {
        width: 244px;
      }
      .image05 {
        width: 253px;
      }
      .image06 {
        width: 279px;
      }
    }
  }
}
</style>
